import type {
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
    LeadScoreRefreshDataInterval,
    Operator,
} from "../../types/types";
import { CrmEnrichmentWizardSteps } from "../../types/types";

export const JOB_TYPE_TRACKING_NAME: Record<CrmEnrichmentJobType, string> = {
    instant: "immediate",
    scheduled: "ongoing",
};

export const ENRICHMENT_SOURCE_TRACKING_NAME: Record<CrmEnrichmentSource, string> = {
    website: "domain level",
    company: "company level",
};

export const JOB_OBJECT_TRACKING_NAME: Record<CrmEnrichmentJobObject, string> = {
    company: "companies",
    contact: "contacts",
    lead: "leads",
};

export const JOB_INTERVAL_TRACKING_NAME: Record<CrmEnrichmentJobRefreshPeriod, string> = {
    never: "never",
    asSoonAsPossible: "as soon as possible",
    twoMonths: "2 months",
    threeMonth: "3 months",
    sixMonth: "6 months",
};

export const LEAD_SCORE_INTERVAL_TRACKING_NAME: Record<LeadScoreRefreshDataInterval, string> = {
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
};

export const JOB_OPERATOR_TRACKING_NAME: Record<Operator, string> = {
    equals: "equals",
    notEquals: "not equals",
    contains: "contains",
    notContains: "not contains",
    greater: "greater",
    lower: "lower",
    empty: "empty",
    notEmpty: "not empty",
};

export const WIZARD_STEP_TRACKING_NAME = {
    [CrmEnrichmentWizardSteps.TypeStep]: "type",
    [CrmEnrichmentWizardSteps.SettingsStep]: "settings",
    [CrmEnrichmentWizardSteps.FiltersStep]: "rules",
    [CrmEnrichmentWizardSteps.ReviewStep]: "review",
};
